import Radio from 'backbone.radio';
import v5_Accounts from '@/collections/v5/accounts';
import v3_Models from '@/collections/v3/models';

export default function(){
    var globalCh = Radio.channel('global');
    var primary_account;
    var active_account;
    globalCh.reply('accounts', function(){
        return v5_Accounts;
    });
    globalCh.reply('v3_models', function(){
        return v3_Models;
    });
    globalCh.reply('active_account', function(){
        if (!active_account) active_account = v5_Accounts.me();
        return active_account;
    });
    globalCh.reply('primary_account', function(){
        if (!primary_account) primary_account = v5_Accounts.me();
        return primary_account;
    });
    globalCh.reply('setActiveAccount', function(account) {
        return primary_account.fetch_permissions_for_account(account).done(()=>{
            active_account = account;
            globalCh.trigger('active_account_change', account);
        });
    });
}
